<nav class="navbar px-2">
  <div class="d-flex justify-content-between align-items-center w-100">

    <a class="navbar-brand" routerLink="/">
      <img src="assets/img/logo/mile-express-no-bg.png" width="100vw" height="35vh" alt="">
    </a>
    <div class="">
      <div class="d-flex align-items-center gap-3">
        <!-- Menu theme -->
        <select class="form-select" [(ngModel)]="currentTheme" (change)="onThemeChange($event)">
          <option value="light">🌞 Light</option>
          <option value="dark">🌙 Dark</option>
        </select>

        <!-- Menu de notificação -->
        <app-notification />

        <!-- Menu -->
        <app-menu [menu]="menu" />

      </div>
    </div>
  </div>
</nav>
